<div class="flex flex-col bg-transparent rounded-lg" data-testid="dashboard-calendar">
  <div class="flex items-center justify-between mb-4">
    <button mat-icon-button class="w-8 h-8 flex items-center justify-center" (click)="onPreviousMonth()">
      <app-icon src="icons/chevron-left.svg" alt="chevron-left" class="w-4 h-4" />
    </button>

    <span class="font-bold text-sm">{{ getMonthYearLabel() }}</span>

    <button mat-icon-button class="w-8 h-8 flex items-center justify-center" (click)="onNextMonth()">
      <app-icon src="icons/chevron-right.svg" alt="chevron-right" class="w-4 h-4" />
    </button>
  </div>

  <div class="grid grid-cols-7 gap-1 mb-2">
    @for (day of daysOfWeek; track day) {
      <div class="text-center text-xs text-shikenso-purple-base-60">{{ day }}</div>
    }
  </div>

  <div class="grid grid-cols-7 gap-1">
    @for (calendarDay of calendarDays(); track calendarDay.id) {
      <div
        class="day-cell rounded-lg relative flex flex-col items-center justify-center min-h-8 w-8 h-8 cursor-pointer"
        [class.current-month]="isCurrentMonth(calendarDay.date)"
        [class.today]="isCurrentDay(calendarDay.date)"
        [class.selected]="isSelectedDay(calendarDay.date)"
        (click)="selectDay(calendarDay.date)"
      >
        <span class="text-xs">{{ calendarDay.date | date: 'd' }}</span>

        @if (calendarDay.hasActiveCampaign) {
          @if (loadingCampaigns()) {
            <ngx-skeleton-loader
              class="absolute flex items-center justify-center bottom-1 w-1 h-1 rounded-full"
              [theme]="{ width: '4px', height: '4px', 'border-radius': '100vw' }"
            />
          } @else {
            <span class="absolute bottom-1 w-1 h-1 rounded-full bg-shikenso-pink-base"></span>
          }
        }
      </div>
    }
  </div>
</div>
